import { defineStore } from 'pinia';
import AcademicPeriodsRepository from "@/Repositories/Indicators/AcademicPeriodsRepository";
import _ from "lodash";
import {EventBus} from "@/event-bus";


export const AcademicPeriodsStore = defineStore('AcademicPeriodsStore', {
    state: () => ({
        academicPeriods: [
        ],

    }),

    actions: {

        /**
         *
         * @param academicPeriods
         */
        setAcademicPeriods(academicPeriods) {
            this.academicPeriods = academicPeriods;
        },

        /**
         * @param academicPeriodId
         * @returns {Promise<void>}
         */
        async getHistoricAcademicPeriods(academicPeriodId) {
            await AcademicPeriodsRepository.getHistoricAcademicPeriods(academicPeriodId).then((response) => {
                this.academicPeriods = response.data;
            }).catch(() => { return []});
        },
    },
})
